import { typographyRem } from '@by-miles/bymiles-styles'

import { GenericSectionStyle } from '../../GenericSectionStyle'
import { AddressContainer } from './components/address/address-container/AddressContainer'
import { OwnershipContainer } from './components/ownership/ownership-container/OwnershipContainer'
import { PurchaseDateContainer } from './components/purchase-date/purchase-date-container/PurchaseDateContainer'
const { h4: H4 } = typographyRem

const CarHistory = () => {
  return (
    <>
      <H4>Your car's history.</H4>
      <GenericSectionStyle>
        <div className="generic-wrapper">
          <PurchaseDateContainer />

          <OwnershipContainer />

          <AddressContainer />
        </div>
      </GenericSectionStyle>
    </>
  )
}

export default CarHistory
